import { TAdminType } from '../../../types.ts';
import { TAdminFormValues } from '../types.ts';

export const normalizeDefaultValues = (data: TAdminType | null): Partial<TAdminFormValues> => {
    return {
        role: data?.role,
        email: data?.email,
    };
};
